/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trip_Force_End_CancelInputs */

const vi_trip_force_end_cancel = /** @type {(inputs: Trip_Force_End_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đóng`)
};

/**

* @param {Trip_Force_End_CancelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trip_force_end_cancel = /** @type {((inputs?: Trip_Force_End_CancelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trip_Force_End_CancelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trip_force_end_cancel(inputs)
});